import Constants from '../Constants';
//const SMS = Constants.TRANSPORT_SMS.toLowerCase(), EMAIL = Constants.TRANSPORT_EMAIL.toLowerCase();
const SMS = Constants.TRANSPORT_SMS, EMAIL = Constants.TRANSPORT_EMAIL;
const Types= {
    SMS,
    EMAIL
}

export default Types;